var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.375 18.3125H36.625L45.6875 9.0625V0H36.625L27.375 9.0625V18.3125Z",
    fill: "#06872C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3125 18.3125V9.0625L9.0625 0H0V9.0625L9.0625 18.3125H18.3125Z",
    fill: "#06872C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.375 18.3125H18.3125V27.375H27.375V18.3125Z",
    fill: "#06872C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.375 27.375V36.625L36.625 45.6875H45.6875V36.625L36.625 27.375H27.375Z",
    fill: "#06872C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.625V45.6875H9.0625L18.3125 36.625V27.375H9.0625L0 36.625Z",
    fill: "#06872C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.06757052ba3db73287c28ef99a879762.svg";
export { ForwardRef as ReactComponent };